import { Typography } from '@mui/material';
import styles from './styles';

const NoResultsFound = () => {
    return (
        <>
            <Typography component="div" sx={styles.emptyResults}>
                No results found.
            </Typography>
            <Typography component="div" style={styles.parentContainer}>
                <img alt="" src="/images/empty-results-bg.svg" />
            </Typography>
        </>
    );
};

export default NoResultsFound;
